<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script lang="ts">
import type { FlexProps } from './primitives/Flex.vue'

export type { Gap } from './primitives/Flex.vue'
export type RowProps = Omit<FlexProps, 'direction'> & { reversed?: boolean }
</script>

<script setup lang="ts">
import Flex from './primitives/Flex.vue'

const { reversed, ...props } = defineProps<RowProps>()
defineSlots<{ default: () => unknown }>()
</script>

<template>
  <Flex v-bind="props" :direction="reversed ? 'row-reverse' : 'row'">
    <slot />
  </Flex>
</template>
